/**
 * D-124: what the CGV promise, shared by the web and the phone: the mark shown in a trainer
 * review request, the time left before the promised deadline, and the « no oral credit left »
 * answer of the examiner (HTTP 402).
 */

export interface ReviewMark {
  score?: number | null;
  band?: number | null;
  nclc?: number | null;
}

/** « 12/20 » (TCF, TEF, Goethe points) or « band 6.5 » (IELTS); « — » when not marked. */
export function formatReviewMark(mark: ReviewMark | null | undefined): string {
  if (!mark) return "—";
  if (mark.band !== null && mark.band !== undefined) return `band ${mark.band}`;
  if (mark.score !== null && mark.score !== undefined) return `${mark.score}/20`;
  return "—";
}

/** The deadline board of one request: hours left (rounded), late or close to the deadline. */
export function reviewUrgency(
  hoursLeft: number | null | undefined,
  warnHours = 24,
): { tone: "danger" | "warning" | "default"; hours: number; late: boolean } {
  if (hoursLeft === null || hoursLeft === undefined) return { tone: "default", hours: 0, late: false };
  const late = hoursLeft < 0;
  return {
    tone: late ? "danger" : hoursLeft <= warnHours ? "warning" : "default",
    hours: Math.round(Math.abs(hoursLeft)),
    late,
  };
}

/** True when the API refused an examiner session because no oral credit is left (402). */
export function isNoOralCredits(error: unknown): boolean {
  return typeof error === "object" && error !== null && (error as { status?: unknown }).status === 402;
}

/** The polite message of the API when given, else none (the screen uses its own text). */
export function noOralCreditsMessage(error: unknown): string {
  const body = (error as { body?: unknown } | null)?.body;
  if (typeof body === "object" && body !== null && typeof (body as { detail?: unknown }).detail === "string") {
    return (body as { detail: string }).detail;
  }
  return "";
}

export const ORAL_CREDITS_EVENT = "academy:no-oral-credits";
